<template>
  <div class="bg">
    <div class="login_box">
      <div class="login">
        <div class="login_left">
          <span>{{ !realExam ? '智谷CTIS区块链模拟考试平台' : '智谷CTIS区块链考试平台' }}</span>
        </div>
        <Card class="login-card">
          <p slot="title">
            登录
          </p>
          <div class="auto-login" v-if="loading">
            <Spin size="large"></Spin>
            <p>正在登录系统，请稍等...</p>
          </div>
          <div class="auto-login-err" v-if="status === 0">
            <p>登录失败，请重试！</p>
            <Button type="primary" @click="autoLogin">重 试</Button>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { Card, Spin, Button } from 'view-design'
export default {
  components: {
    Card,
    Spin,
    Button
  },
  data() {
    return {
      loading: false,
      status: -1 // -1还未请求，0请求失败
    }
  },
  computed: {
    // 是否来源CTIS
    // originCtis() {
    //   return this.$route.name === 'ctis-auto-login'
    // },
    // 是否是真实考试（默认模拟）
    realExam() {
      return localStorage.getItem('realExam') == '1'
    }
  },
  created() {
    this.autoLogin()
  },
  methods: {
    // 判断自动登录
    autoLogin() {
      switch (this.$route.name) {
        case 'ctis-auto-login':
          this.ctisAutoLogin()
          break
        case 'auto-login':
          this.dkyAutoLogin()
          break
        default:
          this.dkyAutoLogin()
      }
    },
    // 登录(电科云)
    async dkyAutoLogin() {
      this.handleBtnLoading = true
      const params = {
        uriCode: 'API015',
        ticket: this.$route.query.ticket
      }
      try {
        this.loading = true
        const res = await this.$fetch(params)
        this.$store.dispatch('clearLocal')
        localStorage.setItem('origin', 'dky')
        // 电科云就是真实考试的
        localStorage.setItem('realExam', this.$route.query.realExam || '1')
        localStorage.setItem('X-Token', res.token)
        this.$msg.success('登录成功')
        this.$router.push({ name: 'home' })
      } catch (err) {
        this.status = 0
      } finally {
        this.loading = false
      }
    },
    // 登录(CTIS)
    async ctisAutoLogin() {
      this.handleBtnLoading = true
      const params = {
        uriCode: 'API016',
        ticket: this.$route.query.ticket
      }
      try {
        this.loading = true
        const res = await this.$fetch(params)

        // 判断如果在考试中就不需要登录直接跳转到考试中的页面
        const examing = localStorage.getItem('examing')
        // 判断只能是同样的ticket才会跳转到考试中页面
        const localUserinfo = localStorage.getItem('userinfo')
        let localUserinfoObj = localUserinfo ? JSON.parse(localUserinfo) : {}
        // 判断只能是同样的ticket才会跳转到考试中页面
        if (examing == '1' && localUserinfoObj.id == res.uid) {
          localStorage.setItem('X-Token', res.token)
          const examingObj = JSON.parse(localStorage.getItem('examParams'))
          this.$router.push({
            name: 'exam',
            params: { eeid: examingObj.eeid, paper_id: examingObj.exam_paper_id },
            query: { end_timestamp: examingObj.end_timestamp }
          })
          return
        }

        this.$store.dispatch('clearLocal')
        // 存储当前是来源是ctis
        localStorage.setItem('origin', 'ctis')
        localStorage.setItem('realExam', this.$route.query.realExam)
        // 存储当前ctis来源信息
        localStorage.setItem('ctisInfo', JSON.stringify(res))
        this.$store.commit('SET_CTISINFO', res)
        localStorage.setItem('X-Token', res.token)
        this.$msg.success('登录成功')
        if (localStorage.getItem('realExam') == '1') {
          this.$router.push({ name: 'home' })
        } else {
          this.$router.push({ name: 'ctis-home' })
        }
      } catch (err) {
        this.status = 0
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bg {
  min-width: 900px;
  min-height: calc(100vh);
  background: url('~@/../public/images/login_bg.png') center no-repeat;
  background-size: cover;
}
.login_box {
  width: 900px;
  min-height: 700px;
  height: calc(100vh);
  position: relative;
  margin: 0 auto;
  .login {
    width: 900px;
    height: 478px;
    display: flex;
    position: absolute;
    top: 25%;
    .login_left {
      width: 420px;
      height: 478px;
      background: url('~@/../public/images/login_img.png') center no-repeat;
      box-sizing: border-box;
      color: #fff;
      text-align: center;
      line-height: 478px;
      font-size: 23px;
      .logo {
        width: 60%;
        margin: 0 auto 80px;
        display: block;
      }
      dl {
        text-align: center;
        dt {
          margin-bottom: 15px;
        }
        img {
          width: 100px;
        }
      }
    }
    &-card {
      border-radius: 0%;
      width: 480px;
      height: 478px;
      margin: 0px auto;
      .card_form {
        box-sizing: border-box;
        padding: 0 60px;
      }
    }
  }
}
.auto-login {
  text-align: center;
  height: 427px;
  padding-top: 130px;
  & > p {
    width: 100%;
    margin-top: 30px;
  }
  .ivu-spin {
    width: 32px;
    height: 32px;
    margin: 0 auto;
  }
}
.auto-login-err {
  text-align: center;
  height: 427px;
  padding-top: 130px;
  & > p {
    width: 100%;
    margin-bottom: 30px;
  }
  button {
    margin: 0 auto;
  }
}
</style>
